<article class="news-list-card">
  <a [title]="newsItem.title" [routerLink]="newsItem.routerLink" class="text-decoration-none news-list-card__wrapper">
    <div class="news-list-card__date">{{ newsItem.updatedOn | date: 'dd-MM-yyyy' }}</div>
    <h1 class="mb-0 type-body-small h3 news-list-card__title">{{ newsItem.title }}</h1>
  </a>
</article>
